import { render, staticRenderFns } from "./tag-selector.vue?vue&type=template&id=626a442f"
import script from "./tag-selector.ts?vue&type=script&lang=ts&external"
export * from "./tag-selector.ts?vue&type=script&lang=ts&external"
import style0 from "./tag-selector.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626a442f')) {
      api.createRecord('626a442f', component.options)
    } else {
      api.reload('626a442f', component.options)
    }
    module.hot.accept("./tag-selector.vue?vue&type=template&id=626a442f", function () {
      api.rerender('626a442f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/focus-topics/tags/tag-selector/tag-selector.vue"
export default component.exports